var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M452.5,506c-17-59.6-74.8-108.1-148.6-124.1v0.8c0,20-16.2,36.1-36.1,36.1h-23.5    c-20,0-36.1-16.2-36.1-36.1v-0.8c-73.9,16-131.6,64.5-148.6,124.1H452.5z",
    fill: "#FBB03B",
    id: "XMLID_7_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.8,418.9h-23.5c-20,0-36.1-16.2-36.1-36.1v-52.4c0-20,16.2-36.1,36.1-36.1h23.5    c20,0,36.1,16.2,36.1,36.1v52.4C303.9,402.7,287.7,418.9,267.8,418.9z",
    fill: "#EDBB98",
    id: "XMLID_6_"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M397.6,240.5c16.2-114.2-15.9-147.3-86.9-176.3c10.4-10.6,11.8-38.8,9.2-39.7   c-6.2,24.7-23.5,34.8-26.5,33.9c6.3-28.4,2.3-51.8-1.2-52.5c-3,33.8-16,48.7-18.4,48.3c9.5-18.7,6.8-37.2,6.8-37.2   C268,47.3,258.4,54.5,254,54.6c7.1-6.1,8.6-21.4,5.5-26C251.7,50,237,55.9,233.9,56.4C171.1,66,93.2,114.9,114.2,240.5   c0,0,111.7,101.4,140.1,36.9l39.7-15.5C322.3,326.4,397.6,240.5,397.6,240.5z",
    fill: "#3F2820",
    id: "XMLID_5_"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 371.3,
    cy: 242.8,
    fill: "#F4C5A2",
    id: "XMLID_4_",
    rx: 26,
    ry: 36,
    transform: "matrix(0.9772 0.2124 -0.2124 0.9772 60.0515 -73.3319)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.7,
    cy: 242.8,
    fill: "#F4C5A2",
    id: "XMLID_3_",
    rx: 26,
    ry: 36,
    transform: "matrix(-0.9772 0.2124 -0.2124 -0.9772 329.7244 450.2195)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.3,
    cy: 238.2,
    fill: "#F4C5A2",
    id: "XMLID_2_",
    rx: 111.9,
    ry: 130.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,135.7l-31-23.6c0.3-0.3,0.5-0.6,0.8-0.9V77.4H178.9c-0.6,1.7-1.2,3.4-1.7,5.3   c0,0-0.7,14.3,14.9,29.6l-30.9,23.5l-14.2,68l3.5,35.8l9.3,1.9c-0.5-23.2,7.4-33.5,7.4-33.5c10.2-12.1,16.4-44.9,16.4-44.9   c4.8-18.5,24.3-31.5,24.3-31.5l4-5.3c12.8,6.1,56.8,24,90.8,2.3l2.3,3.1c0,0,19.5,13,24.3,31.5c0,0,6.2,32.8,16.4,44.9   c0,0,7.9,10.3,7.4,33.5l9.3-1.9l3.5-35.8L351.6,135.7z",
    fill: "#3F2820",
    id: "XMLID_1_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.46978d6225d86671deb4535db7835bb1.svg";
export { ForwardRef as ReactComponent };